import React from 'react';
import { Android as BotIcon, Star as SparkleIcon, Search as SearchIcon, BarChart as AnalyticsIcon } from '@material-ui/icons';
import { Agent } from './types';

export const getAgentIcon = (iconType: string) => {
  switch (iconType) {
    case 'bot':
      return React.createElement(BotIcon);
    case 'star':
      return React.createElement(SparkleIcon);
    case 'search':
      return React.createElement(SearchIcon);
    case 'analytics':
      return React.createElement(AnalyticsIcon);
    default:
      return React.createElement(BotIcon);
  }
};

export const getAgentConfig = (
  agentName: string,
  agentsList: Agent[] = [],
): Agent | undefined => {
  return agentsList.find(agent => agent.name === agentName);
};

export const getAgentPrompts = (
  agentApiName: string,
  agentsList: Agent[] = [],
): Record<string, any[]> => {
  return agentsList.find(a => a.apiName === agentApiName)?.prompts || {};
};
